module.exports = __webpack_public_path__ + "img/logo_login_inferiore.81d60d4c.png";